<template>
    <rkm-modal
        :buttons="buttons"
        :loading="loading"
        :title="`${id ? 'Editar' : 'Novo'} paciente`"
        @save="$refs.Form.save()"
        extraLarge
        ref="Modal"
        no-close-on-backdrop
        no-close-on-esc
    >
        <Form
            v-show="!showBusca"
            :id="id"
            :sem-documentos="semDocumentos"
            :sem-documentos-em="semDocumentosEm"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    components: { Form },
    mixins: [ repository, error ],
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        buttons() {

            return this.showBusca ? [] : ['cancel', 'save']
        },
        showBusca() {

            return !this.id && !this.searched
        },
    },
    data: () => ({
        repositories: {
            dataHora: null,
            geral: null,
        },
        id: null,
        searched: false,
        disabledNextButton: false,
        dataAtual: '',
        termosInvalidos: [],
        semDocumentos: false,
        semDocumentosEm: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            Promise.all([
                this.repositories.dataHora.get({ formato: 'd/m/Y' }),
                this.repositories.geral.getTermosInvalidos(),
            ])
                .then(([dataHoraResponse, termosInvalidosResponse]) => {

                    this.dataAtual = dataHoraResponse.data
                    this.termosInvalidos = termosInvalidosResponse.data.map(t => t.descricao)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        openWithoutDocuments(semDocumentosEm) {

            this.semDocumentosEm = semDocumentosEm
            this.semDocumentos = true
            this.searched = true

            this.$refs.Modal.show()

            this.$nextTick(() => {

                this.$refs.Form.model.cidadao.semDocumentos = true

                this.$refs.Form.loadCidadaoData()
                this.$refs.Form.load()
            })
        },
        open(id) {

            this.semDocumentosEm = null
            this.semDocumentos = false
            this.searched = false
            this.disabledNextButton = false

            this.$refs.Modal.show()

            if (!id) return

            this.id = id

            this.$nextTick(() => {

                this.$refs.Form.model.cidadao.semDocumentos = false

                this.$refs.Form.load()
            })
        },
        handleEdit({ id }) {

            this.id = id
            this.searched = true

            this.$refs.Form.load()
        },
        handleNext(cidadao) {

            this.$refs.CidadaoBusca.validate()
                .then(valid => {

                    if (!valid) return

                    this.searched = true

                    this.$refs.Form.loadCidadaoData(cidadao)
                    this.$refs.Form.load()
                })
        },
        handleExit(paciente) {

            this.$emit('save', paciente)

            this.$refs.Modal.hide()
        },
    },
    created() {

        this.repositories.dataHora = this.getConectaSusRepository('dataHora')
        this.repositories.geral = this.getConectaSusRepository('geral')

        this.load()
    }
}
</script>